import { ITrainingCategory } from '../../../models/allenamenti';

/**
 * Tavolozza proposta.
 *
 * Sono le tinte già usate dalle categorie di sistema: una categoria nuova
 * accostata a quelle esistenti deve sembrare della stessa famiglia, e lasciare
 * scegliere un colore qualsiasi dalla tavolozza di sistema produce accostamenti
 * che nel calendario stonano. Il selettore libero resta, ma di lato.
 */
export const CATEGORY_SWATCHES = [
  '#E2445C',
  '#FF7043',
  '#F2C94C',
  '#27AE60',
  '#2BB3A3',
  '#4375C4',
  '#2F3E6E',
  '#9B51E0',
  '#EB5CA0',
  '#7A8699',
] as const;

/**
 * Oltre questa soglia l'elenco non si scorre più a occhio: serve cercare.
 *
 * Si contano le righe VISIBILI, sotto incluse: a stancare non è il numero di
 * macro (dodici, di sistema) ma le ventisei voci che si scorrono per trovarne
 * una. Contando le sole macro la ricerca non sarebbe mai comparsa.
 */
export const SEARCH_THRESHOLD = 14;

export const countRows = (
  categories: { subcategories: unknown[] }[],
): number =>
  categories.reduce((n, c) => n + 1 + c.subcategories.length, 0);

/**
 * Filtra la tassonomia per testo.
 *
 * Una macro che corrisponde si porta dietro TUTTE le sue sottocategorie: chi
 * cerca «forza» vuole vedere il gruppo Forza intero, non la sola intestazione.
 * Se invece corrisponde solo una sotto, la macro resta come contesto ma mostra
 * le sole figlie pertinenti — altrimenti non si capirebbe dove sta il risultato.
 */
export const filterCategories = (
  categories: ITrainingCategory[],
  query: string,
): ITrainingCategory[] => {
  const q = query.trim().toLowerCase();
  if (!q) return categories;

  return categories.reduce<ITrainingCategory[]>((acc, cat) => {
    if (cat.labelIt.toLowerCase().includes(q)) {
      acc.push(cat);
      return acc;
    }
    const subs = cat.subcategories.filter((s) =>
      s.labelIt.toLowerCase().includes(q),
    );
    if (subs.length) acc.push({ ...cat, subcategories: subs });
    return acc;
  }, []);
};
